import {
	Button,
	Form,
	Input,
	Modal,
	Popconfirm,
	Select,
	Space,
	Spin,
	Typography,
} from "antd";
import React from "react";
import notificationHandler from "../../../atoms/Notification";
import rolesAdmin from "../../../../apis/admin/rolesService";
import { Link, useNavigate, useParams } from "react-router-dom";
import account from "../../../../apis/admin/accoutService";
import {
	ArrowLeftOutlined,
	ExclamationCircleOutlined,
	LoadingOutlined,
	ReloadOutlined,
	SaveOutlined,
} from "@ant-design/icons";
import kitchenAdmin from "../../../../apis/admin/kitchenService";

type Props = {};

const EditAcccount = (props: Props) => {
	const { Title } = Typography;
	const [listRoles, setListRoles] = React.useState<any>();
	const [form] = Form.useForm();
	const { id }: any = useParams();
	const [loading, setLoading] = React.useState(false);
	const navigate = useNavigate();
	const [kitchenName, setKitchenName] = React.useState<any>();
	const [modal, contextHolder] = Modal.useModal();
	const [isResetPass, setIsResetPass] = React.useState<any>(false);
	const [listKitchens, setListKitchens] = React.useState<any[]>([]);

	const listOptionKitchens = listKitchens.map((item: any) => {
		return {
			value: item.id,
			label: item.kitchenName,
		};
	});

	const selectedRoleIds = Form.useWatch("roleIds", form);
	const shouldShowKitchen = selectedRoleIds
		? !selectedRoleIds.includes(1) &&
		  selectedRoleIds.some((roleId: number) => [2, 3].includes(roleId))
		: false;

	const confirm = (values: any) => {
		modal.confirm({
			title: "Bạn có chắc chắn muốn thay đổi dữ liệu?",
			icon: <ExclamationCircleOutlined />,
			okText: "Đồng ý",
			cancelText: "Hủy",
			okType: "danger",
			onOk: () => onFinish(values),
		});
	};
	const { Option } = Select;
	const antIcon = (
		<LoadingOutlined style={{ fontSize: 70, position: "fixed" }} spin />
	);

	const onFinish = (values: any) => {
		const data = {
			username: kitchenName,
			status: values.status,
			roleIds: values.roleIds,
			password: values.password,
			kitchenId: values.kitchenId,
		};
		setLoading(true);
		account
			.updateAcount(id, data)
			.then(() => {
				notificationHandler("success", "Sửa thông tin tài khoản thành công!");
				navigate("/admin/listAccount");
				setLoading(false);
			})
			.catch((err) => {
				notificationHandler("error", err.response.data.data.msg_content);
				setLoading(false);
			});
	};
	React.useEffect(() => {
		account.getUserId(id).then((res: any) => {
			const rolesName = res.data.data.payload.roles.map((item: any) => {
				return item.id;
			});
			const data = {
				status: res.data.data.payload.status,
				roleIds: rolesName,
				kitchenId: res.data.data.payload.kitchenDefault,
			};
			setKitchenName(res.data.data.payload.username);
			form.setFieldsValue(data);
		});
	}, []);
	React.useEffect(() => {
		rolesAdmin
			.getRolesData()
			.then((res: any) => {
				setListRoles(res.data.data.payload);
			})
			.catch((err: any) => {
				notificationHandler("error", err.response.data.data.msg_content);
			});
	}, []);
	React.useEffect(() => {
		kitchenAdmin
			.getKitchenData(1, "")
			.then((res: any) => {
				setListKitchens(res.data.data.payload);
			})
			.catch((err) => {
				notificationHandler("error", "Không thể tải danh sách bếp ăn!");
			});
	}, []);
	return (
		<div className="p-[20px]">
			<Spin indicator={antIcon} spinning={loading} />
			<Title className="text-[20px] mb-[40px]">Sửa thông tin tài khoản</Title>
			<Form
				form={form}
				name="change menu"
				labelCol={{ span: 8 }}
				wrapperCol={{ span: 16 }}
				layout={"vertical"}
				style={{ maxWidth: 600 }}
				onFinish={confirm}
				autoComplete="off"
			>
				<Form.Item label="Tên tài khoản" name="username">
					<Input
						placeholder="Nhập tên tài khoản"
						disabled
						value={kitchenName}
						showCount
						maxLength={200}
					/>
				</Form.Item>
				<Form.Item
					label="Trạng Thái"
					name="status"
					rules={[{ required: true, message: "Vui lòng chọn trạng thái!" }]}
				>
					<Select
						placeholder={"Chọn trạng thái"}
						style={{ width: "100%" }}
						allowClear
						options={[
							{ value: 0, label: "Không hoạt động" },
							{ value: 1, label: "Hoạt động" },
						]}
					/>
				</Form.Item>
				<Form.Item
					name={"roleIds"}
					label={"Danh sách quyền"}
					rules={[{ required: true, message: "Vui lòng chọn quyền!" }]}
				>
					<Select
						mode="multiple"
						style={{ width: "100%" }}
						placeholder="Chọn quyền"
						optionLabelProp="label"
						allowClear
						filterOption={(input, option) => {
							return (
								// @ts-ignore
								option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
							);
						}}
					>
						{listRoles?.map((item: any, key: number) => (
							<Option
								key={item.id}
								value={item.id}
								label={item.roleName}
								className="flex items-center justify-center"
							>
								<span>{item.roleName}</span>
							</Option>
						))}
					</Select>
				</Form.Item>
				{shouldShowKitchen && (
					<Form.Item
						label="Bếp ăn"
						name="kitchenId"
						rules={[{ required: true, message: "Vui lòng chọn bếp ăn!" }]}
					>
						<Select
							style={{ width: "100%" }}
							placeholder={"Chọn bếp ăn"}
							options={listOptionKitchens}
						/>
					</Form.Item>
				)}
				{isResetPass && (
					<>
						{" "}
						<Form.Item
							label="Nhập mật khẩu mới"
							name="password"
							rules={[
								{ required: true, message: "Vui lòng nhập mật khẩu mới!" },
								{
									pattern:
										/(?=(.*[0-9]))(?=.*[\!@#$%^&*()\\[\]{}\-_+=~`|:;"'<>,./?])(?=.*[a-z])(?=(.*[a-z]))(?=(.*)).{8,}|(?=.*[A-Z])(?=.*[0-9])(?=.*[\!@#$%^&*()\\[\]{}\-_+=~`|:;"'<>,./?]).{8,}/,
									message: "Mật khẩu không đủ mạnh",
								},
							]}
						>
							<Input
								placeholder="Nhập mật khẩu mới"
								showCount
								maxLength={50}
								onBlur={(e) =>
									form.setFieldValue("password", e.target.value.trim())
								}
							/>
						</Form.Item>
						<p>Mật khẩu bao gồm chữ cái, chữ số và kí tự đặc biệt</p>
					</>
				)}
				<div className="flex">
					<Button
						htmlType="button"
						type="primary"
						className="mt-4 mr-4 border-[#808080] hover:border-[#808080] hover:text-[#808080] hover:bg-white bg-[#808080] text-white"
					>
						<Link to={"/admin/listAccount"} className="flex items-center">
							<ArrowLeftOutlined className="mr-2" /> Quay lại
						</Link>
					</Button>
					<Button
						htmlType="submit"
						type="primary"
						className="mt-4 bg-[#1890ff] hover:bg-white hover:text-[#1890ff]"
						loading={loading}
					>
						{" "}
						<SaveOutlined />
						Cập nhật
					</Button>
					<Button
						htmlType="reset"
						className="mt-4 text-[##ff4d4f] ml-4  bg-[#ff4d4f] text-white"
						danger
					>
						<ReloadOutlined /> Đặt lại
					</Button>
					{/* <Button
            htmlType="button"
            onClick={() => {
              setIsResetPass(true);
            }}
            type="dashed"
            className="mt-4 text-[##ff4d4f] ml-4  bg-[#f6dc35] text-white"
          >
            <ReloadOutlined /> Resset mật khẩu
          </Button> */}
				</div>
			</Form>
			{contextHolder}
		</div>
	);
};

export default EditAcccount;
